export const EXCEPT_ASIA = ["TH", "ID", "VN", "PH", "IN", "MY"];
export const EXCEPT_EUROPE = ["MU", "CY"];
